import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  ApiBaseUrl,
  sendEmailVerificationV2Api,
  verifyEmailVerificationV2Api,
} from "../../Utils/Constants";
export const hitSendEmailVerificationV2 = createAsyncThunk(
  "hitSendEmailVerificationV2",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + sendEmailVerificationV2Api;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      //showToast(error.response?.data?.message || "Failed to send code", "error");
      throw error.response?.data;
    }
  },
);

export const hitVerifyEmailVerificationV2 = createAsyncThunk(
  "hitVerifyEmailVerificationV2",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + verifyEmailVerificationV2Api;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
);

const EmailVerificationV2Slice = createSlice({
  name: "emailVerificationV2Reducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearEmailVerificationV2Data: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSendEmailVerificationV2.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSendEmailVerificationV2.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSendEmailVerificationV2.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(hitVerifyEmailVerificationV2.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitVerifyEmailVerificationV2.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitVerifyEmailVerificationV2.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearEmailVerificationV2Data } = EmailVerificationV2Slice.actions;
export default EmailVerificationV2Slice.reducer;
